import { useContext } from "react";
import { NavLink } from "react-router-dom";
import { SidebarContext } from "../DashboardLayout";


export function NavSection({ label }: { label: string }) {
  const { isExpanded } = useContext(SidebarContext);
  return (
    <div className="cht-my-2.5 cht-px-1 cht-pt-1.5 cht-pb-0.5">
      <div className="cht-h-[1px] cht-bg-gray-100 cht-mb-2" />
      {isExpanded && (
        <span className="cht-block cht-text-[10px] cht-font-black cht-text-gray-400 cht-uppercase cht-tracking-widest cht-px-2 cht-truncate">
          {label}
        </span>
      )}
    </div>
  );
}

export default function NavItem({ to, icon: Icon, label, end }: any) {
  const { isExpanded } = useContext(SidebarContext);
    return (
      <NavLink
        to={to}
        end={end}
        className={({ isActive }) =>
          [
            "cht-relative cht-flex cht-items-center cht-gap-3 cht-px-[10px] cht-py-[9px] cht-rounded-[10px]",
            "cht-text-sm cht-font-medium cht-transition-all cht-duration-200 cht-group text-decoration-none",
            isActive
              ? "cht-bg-[#3e57da] cht-text-white hover:cht-text-white cht-shadow-[0_4px_14px_rgba(62,87,218,0.28)]"
              : "cht-text-[#1e293b]/65 hover:cht-bg-gray-100 hover:cht-text-[#3e57da]",
          ].join(" ")
        }
      >
        {({ isActive }) => (
          <>
            <Icon size={22} className="cht-flex-shrink-0" />
    
            {/* Label — fades in when sidebar expands */}
            <span
              style={{
                opacity: isExpanded ? 1 : 0,
                width: isExpanded ? "auto" : 0,
                overflow: "hidden",
                whiteSpace: "nowrap",
                transition: "opacity 0.2s ease, width 0.3s ease",
              }}
            >
              {label}
            </span>
    
            {/* Tooltip — visible only when collapsed AND not active */}
            {!isExpanded && !isActive && (
              <span
                className="cht-pointer-events-none cht-absolute cht-left-full cht-ml-3 cht-z-50
                  cht-px-2.5 cht-py-1.5 cht-rounded-[8px] cht-text-xs cht-font-medium
                  cht-bg-[#1e293b] cht-text-white cht-whitespace-nowrap
                  cht-opacity-0 group-hover:cht-opacity-100
                  cht-shadow-lg cht-transition-opacity cht-duration-150"
              >
                {label}
              </span>
            )}
          </>
        )}
      </NavLink>
    );
  };